"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DataBlock = function DataBlock(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(StyledDataBlock, {
    className: className
  }, children);
};

var StyledDataBlock = _styledComponents.default.div.withConfig({
  displayName: "StyledDataBlock"
})(["display:flex;flex-flow:column;justify-content:flex-start;align-items:flex-start;"]);

DataBlock.propTypes = {
  children: _propTypes.node.isRequired,
  className: _propTypes.string
};
var _default = DataBlock;
exports.default = _default;